<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Observações cadastradas'">
          <template v-slot:preview>
            <div col-md-2 col-lg-2>
              <v-btn
                v-if="verificarPermissao(permissoesPadrao.Incluir)"
                color="primary"
                fab
                x-small
                dark
                @click="novaBlacklist"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <v-row>
              <v-col cols="6" offset="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="blacklists"
              :search="search"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
              :expanded.sync="expanded"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>{{ item.nome }}</td>
                  <td>{{ item.valorIdentificacao }}</td>
                  <td style="min-width: 150px" align="center">
                    <v-btn
                      v-if="verificarPermissao(permissoesPadrao.Editar)"
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(item.id)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      v-if="verificarPermissao(permissoesPadrao.Excluir)"
                      color="error"
                      fab
                      x-small
                      dark
                      @click="inativar(item.id, index)"
                      class="ml-2"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                    <v-btn
                      color="primary"
                      fab
                      x-small
                      dark
                      @click="expandObservacao(item)"
                      :loading="pesquisandoImagens[item.id]"
                      class="ml-2"
                      ><v-icon>mdi-eye</v-icon></v-btn
                    >
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  style="
                    white-space: pre-line;
                    padding: 2rem;
                    border: 1px solid rgba(0, 0, 0, 0.12);
                  "
                >
                  <span class="font-weight-medium"
                    ><b class="font-weight-black">MOTIVO: </b>
                    {{ item.motivo?.replace(/ /gm, "\xa0") }}
                  </span>
                  <v-divider
                    v-if="
                      pesquisandoImagens[item.id] === false &&
                      item.anexos.length > 0
                    "
                  ></v-divider>
                  <v-row>
                    <v-col
                      v-if="
                        pesquisandoImagens[item.id] === false &&
                        item.anexos.length > 0
                      "
                    >
                      <h5>Anexos</h5>
                      <p v-for="(anexo, index) in item.anexos" :key="anexo.id">
                        <br />
                        <v-btn
                          color="primary"
                          @click="() => downloadArquivo(anexo)"
                        >
                          <v-icon class="mr-2">fas fa-file</v-icon>
                          {{
                            anexo.nomeArquivoOriginal
                              ? anexo.nomeArquivoOriginal
                              : "Anexo " + (index + 1)
                          }}
                        </v-btn>
                      </p>
                    </v-col>
                    <v-col v-else-if="pesquisandoImagens[item.id]">
                      Carregando anexos...
                    </v-col>
                  </v-row>
                </td>
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { SET_LOADING } from "@/store/config.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import BlacklistService from "@/common/services/http/blacklist.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import axios from "axios";

export default {
  name: "blacklist",
  data() {
    return {
      page: 1,
      permissoesPadrao: {},
      pesquisandoImagens: {},
      itemsPerPage: 1,
      blacklists: [],
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Nome", value: "nome" },
        { text: "Documento", value: "valorIdentificacao" },
        { text: "", value: "" },
      ],
      cliente: {},
      expanded: [],
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    novaBlacklist() {
      this.popularPaginacaoBlacklists();
      this.$router.push({ name: "blacklistCadastro" });
    },

    popularPaginacaoBlacklists() {
      const tabelaBlacklists = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };

      sessionStorage.setItem(
        "tabelaBlacklists",
        JSON.stringify(tabelaBlacklists)
      );
    },

    async listaBlacklists() {
      await BlacklistService.getBlacklistByCliente(this.cliente.id).then(
        ({ data }) => {
          this.page = 1;
          this.itemsPerPage = 10;
          sessionStorage.removeItem("tabelaBlacklists");
          this.blacklists = data;
          this.$store.commit(SET_LOADING, false);
        }
      );
    },

    async downloadArquivo(arquivo) {
      const result = await axios.get(arquivo.caminhoVisualizacao, {
        responseType: "blob",
      });
      const blob = new Blob([result.data]);
      const a = document.createElement("a");
      a.download =
        arquivo.nomeArquivoOriginal ??
        arquivo.nomeBlob.split("/")[arquivo.nomeBlob.split("/").length - 1];
      a.href = URL.createObjectURL(blob);
      a.click();
      URL.revokeObjectURL(a.href);
    },
    async expandObservacao(item) {
      if (!item.anexos) {
        const anexos = await this.carregarImagens(item.id);
        item.anexos = anexos;
      }
      if (this.expanded.includes(item)) {
        this.expanded = this.expanded.filter((d) => item.id != d.id);
        return;
      }

      this.expanded.push(item);
    },

    async carregarImagens(id) {
      this.pesquisandoImagens[id] = true;

      const anexos = [];
      await ApiService.get("registroimagem/getAnexoBlacklistById/" + id)
        .then(({ data }) => {
          if (data.success) {
            anexos.push(...data.data);
          } else {
            SweetAlert.sweetAlertError(data.errors);
          }
        })
        .finally(() => {
          this.pesquisandoImagens[id] = false;
        });

      return anexos;
    },
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Blacklist, permissao);
    },

    editar(id) {
      this.popularPaginacaoBlacklists();
      this.$router.push({ path: "blacklist/cadastro/" + id });
    },

    inativar(id, index) {
      let self = this;
      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("blacklist/" + id + "/inativar").then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Registro de Observação Inativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.blacklists.splice(index, 1);
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Blacklist" }]);
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.listaBlacklists();
    this.permissoesPadrao = Permissoes;
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(
        Modulo.Blacklist,
        Permissoes.Visualizar
      )
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
